module.exports = __webpack_public_path__ + "static/assets/ac6060236cc95c2f7c584df087f0c76c.svg";